// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage, defineMessages } from "react-intl";

export const StartTitle = (): ReactElement => (
    <FormattedMessage id="apps.webLens.components.startTitle" description="Start title." defaultMessage="Web Lenses" />
);
StartTitle.displayName = "StartTitle";

export const FolderLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.folderLabel"
        description="Folder label."
        defaultMessage="Lens Folder"
    />
);
FolderLabel.displayName = "FolderLabel";

export const CreateFolderLink = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.createFolderLink"
        description="Create folder link."
        defaultMessage="Create a new Lens Folder"
    />
);
CreateFolderLink.displayName = "CreateFolderLink";

export const CreateOrganizationLink = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.createOrganizationLink"
        description="Create organization link."
        defaultMessage="Create a new Organization and Lens Folder"
    />
);
CreateOrganizationLink.displayName = "CreateOrganizationLink";

export const ContinueCta = (): ReactElement => (
    <FormattedMessage id="apps.webLens.components.continueCta" description="Continue cta." defaultMessage="Continue" />
);
ContinueCta.displayName = "ContinueCta";

export const GoToLensFoldersCta = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.goToLensFoldersCta"
        description="Go to lens folders cta."
        defaultMessage="Go to Lens Folders"
    />
);
GoToLensFoldersCta.displayName = "GoToLensFoldersCta";

export const LoadOrganizationsFailed = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.loadOrganizationsFailed"
        description="Load organizations failed."
        defaultMessage="Unable to load your organizations. Please refresh and try again."
    />
);
LoadOrganizationsFailed.displayName = "LoadOrganizationsFailed";

export const NoOrganizations = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.noOrganizations"
        description="No organizations."
        defaultMessage="You need an organization with a Lens Folder before submitting a Web Lens."
    />
);
NoOrganizations.displayName = "NoOrganizations";

export const OrganizationNotAccessible = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.organizationNotAccessible"
        description="Organization not accessible."
        defaultMessage="You don't have access to this organization. Switch organizations from the account menu in the top-right corner."
    />
);
OrganizationNotAccessible.displayName = "OrganizationNotAccessible";

export const NoFoldersInOrganization = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.noFoldersInOrganization"
        description="No folders in organization."
        defaultMessage="This organization has no Lens Folders yet. Web Lenses are submitted into a Lens Folder, like any other Lens — create one first."
    />
);
NoFoldersInOrganization.displayName = "NoFoldersInOrganization";

export const ModeCreateOption = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.modeCreateOption"
        description="Mode create option."
        defaultMessage="Submit a new Web Lens"
    />
);
ModeCreateOption.displayName = "ModeCreateOption";

export const ModeUpdateOption = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.modeUpdateOption"
        description="Mode update option."
        defaultMessage="Update an existing Lens"
    />
);
ModeUpdateOption.displayName = "ModeUpdateOption";

export const UpdateNoFoldersInOrganization = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.updateNoFoldersInOrganization"
        description="Update no folders in organization."
        defaultMessage="This organization has no Lens Folders, so it has no Lenses to update."
    />
);
UpdateNoFoldersInOrganization.displayName = "UpdateNoFoldersInOrganization";

export const PageTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.pageTitle"
        description="Page title."
        defaultMessage="Submit a Web Lens"
    />
);
PageTitle.displayName = "PageTitle";

export const PageSubtitle = (props: { documentationLink: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.pageSubtitle"
        description="Page subtitle."
        defaultMessage="Upload a .zip of your production build. See {documentationLink} for more details"
        values={props}
    />
);
PageSubtitle.displayName = "PageSubtitle";

export const DocumentationLink = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.documentationLink"
        description="Documentation link."
        defaultMessage="documentation"
    />
);
DocumentationLink.displayName = "DocumentationLink";

export const UpdatePageTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.updatePageTitle"
        description="Update page title."
        defaultMessage="Update a Web Lens"
    />
);
UpdatePageTitle.displayName = "UpdatePageTitle";

export const UpdatePageSubtitle = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.updatePageSubtitle"
        description="Update page subtitle."
        defaultMessage="Upload a new .zip for this Lens, or change just its name."
    />
);
UpdatePageSubtitle.displayName = "UpdatePageSubtitle";

export const UpdateTarget = (props: { name: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.updateTarget"
        description="Update target."
        defaultMessage="Updating {name}"
        values={props}
    />
);
UpdateTarget.displayName = "UpdateTarget";

export const UpdateTargetId = (props: { lensId: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.updateTargetId"
        description="Update target id."
        defaultMessage="Lens {lensId}"
        values={props}
    />
);
UpdateTargetId.displayName = "UpdateTargetId";

export const ChangeUpdateTarget = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.changeUpdateTarget"
        description="Change update target."
        defaultMessage="Choose a different Lens"
    />
);
ChangeUpdateTarget.displayName = "ChangeUpdateTarget";

export const UpdateCta = (): ReactElement => (
    <FormattedMessage id="apps.webLens.components.updateCta" description="Update cta." defaultMessage="Update" />
);
UpdateCta.displayName = "UpdateCta";

export const UpdatingCta = (): ReactElement => (
    <FormattedMessage id="apps.webLens.components.updatingCta" description="Updating cta." defaultMessage="Updating…" />
);
UpdatingCta.displayName = "UpdatingCta";

export const UpdateRailHelper = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.updateRailHelper"
        description="Update rail helper."
        defaultMessage="The new package replaces the current version once conversion and review finish. Until then the current version keeps serving."
    />
);
UpdateRailHelper.displayName = "UpdateRailHelper";

export const RenameRailHelper = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.renameRailHelper"
        description="Rename rail helper."
        defaultMessage="The renamed version replaces the current one once processing and review finish. Until then the current version keeps serving. No new package and no conversion re-run — but a published Lens is reviewed again."
    />
);
RenameRailHelper.displayName = "RenameRailHelper";

export const SubmitDestination = (props: { organization: ReactNode; folder: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.submitDestination"
        description="Submit destination."
        defaultMessage="Submitting to {organization} / {folder}"
        values={props}
    />
);
SubmitDestination.displayName = "SubmitDestination";

export const ChangeDestination = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.changeDestination"
        description="Change destination."
        defaultMessage="Change"
    />
);
ChangeDestination.displayName = "ChangeDestination";

export const PackageSectionTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.packageSectionTitle"
        description="Package section title."
        defaultMessage="Package"
    />
);
PackageSectionTitle.displayName = "PackageSectionTitle";

export const DropzonePrompt = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.dropzonePrompt"
        description="Dropzone prompt."
        defaultMessage="Drop a .zip of your production build here"
    />
);
DropzonePrompt.displayName = "DropzonePrompt";

export const DropzoneHint = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.dropzoneHint"
        description="Dropzone hint."
        defaultMessage="Please ensure it follows the package requirements"
    />
);
DropzoneHint.displayName = "DropzoneHint";

export const PackageMeta = (props: { size: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.packageMeta"
        description="Package meta."
        defaultMessage="{size} · zip of your build output (dist/)"
        values={props}
    />
);
PackageMeta.displayName = "PackageMeta";

export const PackageBudgetMeter = (props: { used: ReactNode; limit: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.packageBudgetMeter"
        description="Package budget meter."
        defaultMessage="Build output: {used} of the {limit} Lens budget"
        values={props}
    />
);
PackageBudgetMeter.displayName = "PackageBudgetMeter";

export const PackageBudgetOver = (props: { used: ReactNode; limit: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.packageBudgetOver"
        description="Package budget over."
        defaultMessage="Build output: {used} — over the {limit} Lens budget"
        values={props}
    />
);
PackageBudgetOver.displayName = "PackageBudgetOver";

export const PackageRequirementsTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.packageRequirementsTitle"
        description="Package requirements title."
        defaultMessage="Package requirements"
    />
);
PackageRequirementsTitle.displayName = "PackageRequirementsTitle";

export const RequirementZip = (props: { limit: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.requirementZip"
        description="Requirement zip."
        defaultMessage="A .zip up to {limit} — your whole project or just your build output (dist/)"
        values={props}
    />
);
RequirementZip.displayName = "RequirementZip";

export const RequirementUnzipped = (props: { size: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.requirementUnzipped"
        description="Requirement unzipped."
        defaultMessage="Unzips to at most {size} and 20,000 files"
        values={props}
    />
);
RequirementUnzipped.displayName = "RequirementUnzipped";

export const RequirementBuiltOutput = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.requirementBuiltOutput"
        description="Requirement built output."
        defaultMessage="Contains an index.html at the archive root or inside dist/, build/, out/ or www/"
    />
);
RequirementBuiltOutput.displayName = "RequirementBuiltOutput";

export const RequirementNoSource = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.requirementNoSource"
        description="Requirement no source."
        defaultMessage="The build output holds only built files — no .ts/.tsx/.jsx or /src/ references (sources elsewhere in the zip are ignored)"
    />
);
RequirementNoSource.displayName = "RequirementNoSource";

export const RequirementBundle = (props: { limit: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.requirementBundle"
        description="Requirement bundle."
        defaultMessage="Only the build output becomes the Lens — it must fit in {limit} compressed; sources zipped alongside it don't count"
        values={props}
    />
);
RequirementBundle.displayName = "RequirementBundle";

export const ReplacePackageCta = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.replacePackageCta"
        description="Replace package cta."
        defaultMessage="Replace"
    />
);
ReplacePackageCta.displayName = "ReplacePackageCta";

export const DetailsSectionTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.detailsSectionTitle"
        description="Details section title."
        defaultMessage="Lens details"
    />
);
DetailsSectionTitle.displayName = "DetailsSectionTitle";

export const NameCounter = (props: { count: ReactNode; max: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.nameCounter"
        description="Name counter."
        defaultMessage="{count} / {max} characters"
        values={props}
    />
);
NameCounter.displayName = "NameCounter";

export const UploadLogoCta = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.uploadLogoCta"
        description="Upload logo cta."
        defaultMessage="Upload icon"
    />
);
UploadLogoCta.displayName = "UploadLogoCta";

export const LogoPlaceholder = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.logoPlaceholder"
        description="Logo placeholder."
        defaultMessage="PNG"
    />
);
LogoPlaceholder.displayName = "LogoPlaceholder";

export const RailTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.railTitle"
        description="Rail title."
        defaultMessage="Ready to submit"
    />
);
RailTitle.displayName = "RailTitle";

export const RequirementPreviewGame = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.requirementPreviewGame"
        description="Requirement preview game."
        defaultMessage="Game Lens: a 5–10s gameplay video"
    />
);
RequirementPreviewGame.displayName = "RequirementPreviewGame";

export const RequirementPreviewVideo = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.requirementPreviewVideo"
        description="Requirement preview video."
        defaultMessage="Web Lens: a 5–10s video preview"
    />
);
RequirementPreviewVideo.displayName = "RequirementPreviewVideo";

export const SubmitCta = (): ReactElement => (
    <FormattedMessage id="apps.webLens.components.submitCta" description="Submit cta." defaultMessage="Submit" />
);
SubmitCta.displayName = "SubmitCta";

export const SaveAsDraftCta = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.saveAsDraftCta"
        description="Save as draft cta."
        defaultMessage="Save as Draft"
    />
);
SaveAsDraftCta.displayName = "SaveAsDraftCta";

export const SubmittingCta = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.submittingCta"
        description="Submitting cta."
        defaultMessage="Submitting…"
    />
);
SubmittingCta.displayName = "SubmittingCta";

export const LogoHint = (props: { limit: ReactNode; dimension: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.logoHint"
        description="Logo hint."
        defaultMessage="PNG, {limit} max, up to {dimension} × {dimension} px"
        values={props}
    />
);
LogoHint.displayName = "LogoHint";

export const ReplaceLogoCta = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.replaceLogoCta"
        description="Replace logo cta."
        defaultMessage="Replace icon"
    />
);
ReplaceLogoCta.displayName = "ReplaceLogoCta";

export const UpdateLogoHint = (props: { limit: ReactNode; dimension: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.updateLogoHint"
        description="Update logo hint."
        defaultMessage="PNG, {limit} max, up to {dimension} × {dimension} px. Leave it alone to keep the current icon."
        values={props}
    />
);
UpdateLogoHint.displayName = "UpdateLogoHint";

export const ModePushOption = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.modePushOption"
        description="Mode push option."
        defaultMessage="Preview on Snapchat"
    />
);
ModePushOption.displayName = "ModePushOption";

export const PushModeFolderHint = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.pushModeFolderHint"
        description="Push mode folder hint."
        defaultMessage="No Lens Folder is needed. The preview is private to your account and isn't saved to your organization."
    />
);
PushModeFolderHint.displayName = "PushModeFolderHint";

export const PushPageTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.pushPageTitle"
        description="Push page title."
        defaultMessage="Preview on Snapchat"
    />
);
PushPageTitle.displayName = "PushPageTitle";

export const PushPageSubtitle = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.pushPageSubtitle"
        description="Push page subtitle."
        defaultMessage="Upload a .zip of your web app build and try it in Snapchat on your phone. The preview is temporary and private to your account."
    />
);
PushPageSubtitle.displayName = "PushPageSubtitle";

export const PushRailTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.pushRailTitle"
        description="Push rail title."
        defaultMessage="Ready to send"
    />
);
PushRailTitle.displayName = "PushRailTitle";

export const PushRailHelper = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.pushRailHelper"
        description="Push rail helper."
        defaultMessage="Your web app is converted and sent to the Snapchat account you're signed in with. If it can't be converted, the reason shows here."
    />
);
PushRailHelper.displayName = "PushRailHelper";

export const PushCta = (): ReactElement => (
    <FormattedMessage id="apps.webLens.components.pushCta" description="Push cta." defaultMessage="Send to Snapchat" />
);
PushCta.displayName = "PushCta";

export const PushingCta = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.pushingCta"
        description="Pushing cta."
        defaultMessage="Sending Lens…"
    />
);
PushingCta.displayName = "PushingCta";

export const PushAgainCta = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.pushAgainCta"
        description="Push again cta."
        defaultMessage="Send again"
    />
);
PushAgainCta.displayName = "PushAgainCta";

export const PushSuccessTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.pushSuccessTitle"
        description="Push success title."
        defaultMessage="Lens sent!"
    />
);
PushSuccessTitle.displayName = "PushSuccessTitle";

export const PushSuccessBody = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.pushSuccessBody"
        description="Push success body."
        defaultMessage="Open Snapchat on your phone and look for the notification from Team Snapchat, or find your Lens in the Lens carousel. You can rebuild and send again anytime."
    />
);
PushSuccessBody.displayName = "PushSuccessBody";

export const PushNameHint = (): ReactElement => (
    <FormattedMessage
        id="apps.webLens.components.pushNameHint"
        description="Push name hint."
        defaultMessage="The name shown on the preview Lens."
    />
);
PushNameHint.displayName = "PushNameHint";

export const messages = defineMessages({
    searchLensesPlaceholder: {
        id: "apps.webLens.components.searchLensesPlaceholder",
        description: "Search lenses placeholder.",
        defaultMessage: "Search Lenses",
    },
    lensFolderPermissionCheckLabel: {
        id: "apps.webLens.components.lensFolderPermissionCheckLabel",
        description: "Lens folder permission check label.",
        defaultMessage: "Lens Folder submission access",
    },
    lensFolderPermissionCheckFail: {
        id: "apps.webLens.components.lensFolderPermissionCheckFail",
        description: "Lens folder permission check fail.",
        defaultMessage:
            "You don't have permission to submit Lenses to this Lens Folder. Contact a Lens Folder admin for access.",
    },
    lensFolderPermissionCheckLoadFail: {
        id: "apps.webLens.components.lensFolderPermissionCheckLoadFail",
        description: "Lens folder permission check load fail.",
        defaultMessage: "Unable to load Lens Folder permissions. Refresh and try again.",
    },
    webLensPreviewRequirement: {
        id: "apps.webLens.components.webLensPreviewRequirement",
        description: "Web lens preview requirement.",
        defaultMessage: "To publish, upload a 5–10s video of someone using your Lens to help speed up review.",
    },
    folderTooltip: {
        id: "apps.webLens.components.folderTooltip",
        description: "Folder tooltip.",
        defaultMessage: "Web Lenses are submitted into a Lens Folder, like any other Lens.",
    },
    folderPlaceholder: {
        id: "apps.webLens.components.folderPlaceholder",
        description: "Folder placeholder.",
        defaultMessage: "Select a Lens Folder",
    },
    nameLabel: {
        id: "apps.webLens.components.nameLabel",
        description: "Name label.",
        defaultMessage: "Lens Name",
    },
    logoLabel: {
        id: "apps.webLens.components.logoLabel",
        description: "Logo label.",
        defaultMessage: "Lens Icon",
    },
    logoPreviewAlt: {
        id: "apps.webLens.components.logoPreviewAlt",
        description: "Logo preview alt.",
        defaultMessage: "Lens icon preview",
    },
    visibilityLabel: {
        id: "apps.webLens.components.visibilityLabel",
        description: "Visibility label.",
        defaultMessage: "Visibility",
    },
    visibilityDontPublish: {
        id: "apps.webLens.components.visibilityDontPublish",
        description: "Visibility dont publish.",
        defaultMessage: "Don't publish to Snapchat",
    },
    visibilityPublic: {
        id: "apps.webLens.components.visibilityPublic",
        description: "Visibility public.",
        defaultMessage: "Public",
    },
    checkPackageTypeLabel: {
        id: "apps.webLens.components.checkPackageTypeLabel",
        description: "Check package type label.",
        defaultMessage: "Package is a valid .zip",
    },
    checkPackageTypeFailDetail: {
        id: "apps.webLens.components.checkPackageTypeFailDetail",
        description: "Check package type fail detail.",
        defaultMessage: "{fileName} — upload a .zip of your project including its build output",
    },
    checkPackageSizeLabel: {
        id: "apps.webLens.components.checkPackageSizeLabel",
        description: "Check package size label.",
        defaultMessage: "Under the {limit} limit",
    },
    checkPackageEmptyDetail: {
        id: "apps.webLens.components.checkPackageEmptyDetail",
        description: "Check package empty detail.",
        defaultMessage: "Empty archive — zip your build output and retry",
    },
    checkBudgetLabel: {
        id: "apps.webLens.components.checkBudgetLabel",
        description: "Check budget label.",
        defaultMessage: "Build output within the {limit} Lens budget",
    },
    checkBudgetFailDetail: {
        id: "apps.webLens.components.checkBudgetFailDetail",
        description: "Check budget fail detail.",
        defaultMessage: "measured {used} — reduce your assets and re-zip",
    },
    checkNameLabel: {
        id: "apps.webLens.components.checkNameLabel",
        description: "Check name label.",
        defaultMessage: "Lens name set",
    },
    checkPreviewLabel: {
        id: "apps.webLens.components.checkPreviewLabel",
        description: "Check preview label.",
        defaultMessage: "5–10s video preview attached",
    },
    checkStatePass: {
        id: "apps.webLens.components.checkStatePass",
        description: "Check state pass.",
        defaultMessage: "Ready",
    },
    checkStateFail: {
        id: "apps.webLens.components.checkStateFail",
        description: "Check state fail.",
        defaultMessage: "Needs attention",
    },
    checkStatePending: {
        id: "apps.webLens.components.checkStatePending",
        description: "Check state pending.",
        defaultMessage: "Not started",
    },
    checkLogoTypeLabel: {
        id: "apps.webLens.components.checkLogoTypeLabel",
        description: "Check logo type label.",
        defaultMessage: "Lens icon is a .png",
    },
    checkLogoSizeLabel: {
        id: "apps.webLens.components.checkLogoSizeLabel",
        description: "Check logo size label.",
        defaultMessage: "Lens icon under {limit}",
    },
    uploadCheckLabel: {
        id: "apps.webLens.components.uploadCheckLabel",
        description: "Upload check label.",
        defaultMessage: "Upload package",
    },
    serverCheckLabel: {
        id: "apps.webLens.components.serverCheckLabel",
        description: "Server check label.",
        defaultMessage: "Submit for processing",
    },
    updateCheckLabel: {
        id: "apps.webLens.components.updateCheckLabel",
        description: "Update check label.",
        defaultMessage: "Update the Lens",
    },
    renameCheckLabel: {
        id: "apps.webLens.components.renameCheckLabel",
        description: "Rename check label.",
        defaultMessage: "Rename the Lens",
    },
    renameFailed: {
        id: "apps.webLens.components.renameFailed",
        description: "Rename failed.",
        defaultMessage: "Unable to rename. If the Lens is still processing, wait for it to finish and retry.",
    },
    checkRenameLabel: {
        id: "apps.webLens.components.checkRenameLabel",
        description: "Check rename label.",
        defaultMessage: "Rename only",
    },
    checkRenameDetail: {
        id: "apps.webLens.components.checkRenameDetail",
        description: "Check rename detail.",
        defaultMessage:
            "“{current}” becomes “{name}”. The current package is kept — no conversion re-run, though a published Lens is reviewed again.",
    },
    checkRenameBlockedFailedUpdateDetail: {
        id: "apps.webLens.components.checkRenameBlockedFailedUpdateDetail",
        description: "Check rename blocked failed update detail.",
        defaultMessage:
            "Not available: this Lens's latest version failed processing or review, and a rename alone would re-run it. Upload a new package to rename it.",
    },
    updateLensLocked: {
        id: "apps.webLens.components.updateLensLocked",
        description: "Update lens locked.",
        defaultMessage: "This Lens is still processing a version — updates are rejected until it finishes.",
    },
    updateLatestVersionFailed: {
        id: "apps.webLens.components.updateLatestVersionFailed",
        description: "Update latest version failed.",
        defaultMessage:
            "This Lens's latest version failed processing or review. A rename alone would re-run it, so upload a new package to update the Lens — you can change the name at the same time.",
    },
    updateLensLoadFailed: {
        id: "apps.webLens.components.updateLensLoadFailed",
        description: "Update lens load failed.",
        defaultMessage: "Unable to load this Lens. Check the Lens id, or refresh and try again.",
    },
    updateNameHint: {
        id: "apps.webLens.components.updateNameHint",
        description: "Update name hint.",
        defaultMessage:
            "Change only the name to rename the Lens without uploading a new package. Leave it unchanged to keep it.",
    },
    nameErrorRequired: {
        id: "apps.webLens.components.nameErrorRequired",
        description: "Name error required.",
        defaultMessage: "Enter a Lens name",
    },
    nameErrorTooLong: {
        id: "apps.webLens.components.nameErrorTooLong",
        description: "Name error too long.",
        defaultMessage: "At most {max} characters",
    },
    nameErrorUnsupportedCharacters: {
        id: "apps.webLens.components.nameErrorUnsupportedCharacters",
        description: "Name error unsupported characters.",
        defaultMessage: "Only letters, numbers, spaces and common punctuation",
    },
    currentLogoAlt: {
        id: "apps.webLens.components.currentLogoAlt",
        description: "Current logo alt.",
        defaultMessage: "Current Lens icon",
    },
    uploadFailedNetwork: {
        id: "apps.webLens.components.uploadFailedNetwork",
        description: "Upload failed network.",
        defaultMessage: "upload failed (network error) — check your connection and retry",
    },
    uploadFailedStalled: {
        id: "apps.webLens.components.uploadFailedStalled",
        description: "Upload failed stalled.",
        defaultMessage: "upload stalled — check your connection and retry",
    },
    uploadFailedHttp: {
        id: "apps.webLens.components.uploadFailedHttp",
        description: "Upload failed http.",
        defaultMessage: "upload failed (HTTP {status})",
    },
    uploadFailedFileChanged: {
        id: "apps.webLens.components.uploadFailedFileChanged",
        description: "Upload failed file changed.",
        defaultMessage: "the file changed since you selected it — choose it again and retry",
    },
    genericFailure: {
        id: "apps.webLens.components.genericFailure",
        description: "Generic failure.",
        defaultMessage: "Unable to complete. Please try again.",
    },
    pushCheckLabel: {
        id: "apps.webLens.components.pushCheckLabel",
        description: "Push check label.",
        defaultMessage: "Send to Snapchat",
    },
    checkLogoDimensionLabel: {
        id: "apps.webLens.components.checkLogoDimensionLabel",
        description: "Check logo dimension label.",
        defaultMessage: "Lens icon at most {limit} × {limit} px",
    },
    rejectionReasonConversionFailure: {
        id: "apps.webLens.components.rejectionReasonConversionFailure",
        description: "Rejection reason conversion failure.",
        defaultMessage:
            "Your web app couldn't be converted into a Lens. Check that the package contains your production build output, then send again.",
    },
    rejectionReasonPackageUnreadable: {
        id: "apps.webLens.components.rejectionReasonPackageUnreadable",
        description: "Rejection reason package unreadable.",
        defaultMessage:
            "Your package couldn't be read as a .zip archive. Re-export your build and upload a valid .zip.",
    },
    rejectionReasonPackageTooLarge: {
        id: "apps.webLens.components.rejectionReasonPackageTooLarge",
        description: "Rejection reason package too large.",
        defaultMessage: "Your package is over the size limits. Reduce the package size, then send again.",
    },
    rejectionReasonUnsafeArchiveEntry: {
        id: "apps.webLens.components.rejectionReasonUnsafeArchiveEntry",
        description: "Rejection reason unsafe archive entry.",
        defaultMessage:
            "Your package contains unsafe file paths. Re-create the .zip from your build output folder, then send again.",
    },
    rejectionReasonBundleTooLarge: {
        id: "apps.webLens.components.rejectionReasonBundleTooLarge",
        description: "Rejection reason bundle too large.",
        defaultMessage: "The converted Lens is over the size limit. Reduce your asset sizes, then send again.",
    },
    rejectionNotZip: {
        id: "apps.webLens.components.rejectionNotZip",
        description: "Rejection not zip.",
        defaultMessage: "Your upload couldn't be read as a .zip archive. Re-export your build and upload a valid .zip.",
    },
    rejectionCompressedOverLimit: {
        id: "apps.webLens.components.rejectionCompressedOverLimit",
        description: "Rejection compressed over limit.",
        defaultMessage: "Your package is larger than {limit} MB. Reduce the package size, then send again.",
    },
    rejectionInflatedOverLimit: {
        id: "apps.webLens.components.rejectionInflatedOverLimit",
        description: "Rejection inflated over limit.",
        defaultMessage:
            "Your package expands to more than {limit} MB when unzipped. Reduce the package size, then send again.",
    },
    rejectionEntryCountOverLimit: {
        id: "apps.webLens.components.rejectionEntryCountOverLimit",
        description: "Rejection entry count over limit.",
        defaultMessage: "Your package contains more than {limit} files. Reduce the number of files, then send again.",
    },
    rejectionNoBuiltOutput: {
        id: "apps.webLens.components.rejectionNoBuiltOutput",
        description: "Rejection no built output.",
        defaultMessage:
            "No index.html was found in {dirs} or at the archive root. Run your production build and upload its output.",
    },
    rejectionSourceProject: {
        id: "apps.webLens.components.rejectionSourceProject",
        description: "Rejection source project.",
        defaultMessage:
            "Your upload looks like an unbuilt source project. Run your production build and upload its output directory (for example dist/), not the project source.",
    },
    rejectionSourceFiles: {
        id: "apps.webLens.components.rejectionSourceFiles",
        description: "Rejection source files.",
        defaultMessage:
            "Your build output contains {count} source file(s). Upload only your built output, not project sources.",
    },
    rejectionDevEntry: {
        id: "apps.webLens.components.rejectionDevEntry",
        description: "Rejection dev entry.",
        defaultMessage:
            "Your index.html references unbuilt sources under /src/, which means it is a development entry point. Run your production build and upload its output.",
    },
    rejectionMissingRefs: {
        id: "apps.webLens.components.rejectionMissingRefs",
        description: "Rejection missing refs.",
        defaultMessage:
            "Your index.html references files that are not in the package: {refs}. Re-create the .zip with your complete build output.",
    },
    rejectionBundleOverLimit: {
        id: "apps.webLens.components.rejectionBundleOverLimit",
        description: "Rejection bundle over limit.",
        defaultMessage: "The converted Lens exceeds {limit} MB. Reduce your asset sizes, then send again.",
    },
    rejectionSecurityFailed: {
        id: "apps.webLens.components.rejectionSecurityFailed",
        description: "Rejection security failed.",
        defaultMessage: "Security scan failed. Fix the issues below, rebuild your web app, and send again.",
    },
    rejectionSecurityFailedNoDetails: {
        id: "apps.webLens.components.rejectionSecurityFailedNoDetails",
        description: "Rejection security failed no details.",
        defaultMessage:
            "Security scan failed. Check your built web app for unsupported features, then rebuild and send again.",
    },
    rejectionSecurityFinding: {
        id: "apps.webLens.components.rejectionSecurityFinding",
        description: "Rejection security finding.",
        defaultMessage:
            "{rule} Example: {file}:{line}:{column} ({occurrences, plural, one {# occurrence} other {# occurrences}}).",
    },
    rejectionSecurityMore: {
        id: "apps.webLens.components.rejectionSecurityMore",
        description: "Rejection security more.",
        defaultMessage:
            "{count, plural, one {# additional finding was detected.} other {# additional findings were detected.}}",
    },
    rejectionRuleRtc001: {
        id: "apps.webLens.components.rejectionRuleRtc001",
        description: "Rejection rule rtc001.",
        defaultMessage:
            "WebRTC connections are not supported. Remove WebRTC usage. To save progress or share scores, use the Web Lens API instead. See https://developers.snap.com/web-lenses/web-lens-api for storage and leaderboards.",
    },
    rejectionRuleRtc002: {
        id: "apps.webLens.components.rejectionRuleRtc002",
        description: "Rejection rule rtc002.",
        defaultMessage:
            "WebRTC relay servers are not supported. Remove STUN/TURN server addresses and the code that uses them. To save progress or share scores, use the Web Lens API instead. See https://developers.snap.com/web-lenses/web-lens-api for storage and leaderboards.",
    },
    rejectionRuleNet001: {
        id: "apps.webLens.components.rejectionRuleNet001",
        description: "Rejection rule net001.",
        defaultMessage:
            "External network requests are not supported. Remove requests to external URLs and include required resources in your build. To save progress, share scores, or get Bitmoji avatars, use the Web Lens API instead. See https://developers.snap.com/web-lenses/web-lens-api for details.",
    },
    rejectionRuleNet003: {
        id: "apps.webLens.components.rejectionRuleNet003",
        description: "Rejection rule net003.",
        defaultMessage:
            "Socket and streaming connections are not supported. Remove WebSocket, EventSource, or WebTransport usage. To save progress or share scores, use the Web Lens API instead. See https://developers.snap.com/web-lenses/web-lens-api for storage and leaderboards.",
    },
    rejectionRuleNet005: {
        id: "apps.webLens.components.rejectionRuleNet005",
        description: "Rejection rule net005.",
        defaultMessage:
            "Remote scripts and workers are not supported. Include their code in your uploaded build and use local paths.",
    },
    rejectionRuleRealm002: {
        id: "apps.webLens.components.rejectionRuleRealm002",
        description: "Rejection rule realm002.",
        defaultMessage:
            "Access to another frame's browser context is not supported. Remove cross-frame window or document access.",
    },
    rejectionRuleDev001: {
        id: "apps.webLens.components.rejectionRuleDev001",
        description: "Rejection rule dev001.",
        defaultMessage:
            "Web Lenses can't open the device camera or microphone themselves (getUserMedia, getDisplayMedia, ImageCapture). Snapchat disables the live camera for web lenses, so remove the capture code and any video preview that depends on it, then send again.",
    },
    rejectionRuleDev002: {
        id: "apps.webLens.components.rejectionRuleDev002",
        description: "Rejection rule dev002.",
        defaultMessage: "Device location access is not supported. Remove browser geolocation API usage.",
    },
    rejectionRuleDyn003: {
        id: "apps.webLens.components.rejectionRuleDyn003",
        description: "Rejection rule dyn003.",
        defaultMessage:
            "A restricted browser API was referenced through a string or encoded text. Remove that reference and the code that uses it.",
    },
    rejectionRuleFs001: {
        id: "apps.webLens.components.rejectionRuleFs001",
        description: "Rejection rule fs001.",
        defaultMessage:
            "Symbolic links are not supported. Replace them with the actual files inside your build folder.",
    },
    rejectionRuleFs002: {
        id: "apps.webLens.components.rejectionRuleFs002",
        description: "Rejection rule fs002.",
        defaultMessage:
            "An archive file points outside the build folder. Use relative file paths without parent-directory (..) segments.",
    },
    rejectionRuleScan001: {
        id: "apps.webLens.components.rejectionRuleScan001",
        description: "Rejection rule scan001.",
        defaultMessage:
            "The scan could not finish within its limits. Reduce the size or complexity of your built scripts and remove unused files.",
    },
    rejectionRuleUnknown: {
        id: "apps.webLens.components.rejectionRuleUnknown",
        description: "Rejection rule unknown.",
        defaultMessage: "Unsupported feature ({ruleId}).",
    },
    serverCheckCreateLens: {
        id: "apps.webLens.components.serverCheckCreateLens",
        description: "Server check create lens.",
        defaultMessage: "Create Lens",
    },
    serverCheckLogoReadable: {
        id: "apps.webLens.components.serverCheckLogoReadable",
        description: "Server check logo readable.",
        defaultMessage: "Lens icon readable",
    },
    serverCheckPackageReadable: {
        id: "apps.webLens.components.serverCheckPackageReadable",
        description: "Server check package readable.",
        defaultMessage: "Package readable",
    },
    serverCheckPushLens: {
        id: "apps.webLens.components.serverCheckPushLens",
        description: "Server check push lens.",
        defaultMessage: "Push Lens",
    },
    serverCheckUpdateLens: {
        id: "apps.webLens.components.serverCheckUpdateLens",
        description: "Server check update lens.",
        defaultMessage: "Update Lens",
    },
});
